module.exports = __webpack_public_path__ + "static/media/illustration1.a0da496a.svg";